import UserManager from './userManager';
const oidcConfig = {
    userManager: UserManager
};
export default oidcConfig;
